import { NgModule } from '@angular/core';

import { SharedModule } from '../../../../shared';
import { CampanhaSelectModule } from '../../../campanhas/campanhas/components/select';
import { CampanhaViewEmbeddedModule } from '../../../campanhas/campanhas/view/embedded/campanha-view-embedded.module';
import { CidadeModule } from '../../../cidade';
import { CNAEsViewModule } from '../../../cnaes/components/cnaes-view';
import { CNAEPipeModule } from '../../../cnaes/pipes';
import { CanalVendaInputGroupModule } from '../../../common/canais-venda/components/input-group';
import { CanalVendaSelectModule } from '../../../common/canais-venda/components/select';
import { CanalMidiaSocialInputGroupModule } from '../../../common/canal-midia-social/components/input-group';
import { CanalMidiaSocialSelectModule } from '../../../common/canal-midia-social/components/select';
import { CapitalSocialFormControlTextModule } from '../../../common/capital-social/form-control-text';
import { MEIFormModule } from '../../../common/mei';
import { MoedaPipeModule } from '../../../common/moeda/pipes';
import { OrigemInputGroupModule } from '../../../common/origens/components/input-group';
import { OrigemSelectModule } from '../../../common/origens/components/select';
import { SimplesNacionalFormModule } from '../../../common/simples-nacional';
import { SocioViewModule } from '../../../common/socios/view';
import { CurvaAbcVendaModule } from '../../../consultas/curva-abc-venda';
import { CustomerShareIndicadorBadgeModule } from '../../../pic/customer-share/indicador/badge';
import { RegiaoSelectModule } from '../../../regiao/select';
import { TabelaPrecoSelectModule } from '../../../tabela-preco/select';
import { TituloReceberResumoModule } from '../../../titulo-receber/resumo/titulo-receber-resumo.module';
import { TituloReceberSituacaoModule } from '../../../titulo-receber/situacao/titulo-receber-situacao.module';
import { UnidadeNegocioSharedModule } from '../../../unidade-negocio';
import { UsuarioSharedModule } from '../../../usuario/usuario-shared.module';
import { PessoaIPIFormModule } from '../../components/ipi';
import { PessoaSharedModule } from '../../pessoa-shared.module';
import { RepresentanteSharedModule } from '../../representante';
import { PessoaTermoLGPDFormModule } from '../../termo-lgpd/form';
import { PessoaTipoPipeModule } from '../../tipo';
import { PessoaTipoCardControlRadioModule } from '../../tipo/card-control-radio';
import { ClienteAnaliseFinanceiraModule } from '../analise-financeira';
import { ClienteAnaliseFinanceiraBtnOptionsModule } from '../analise-financeira/btn-options';
import { ClienteAnaliseFinanceiraConcluirModule } from '../analise-financeira/concluir-modal';
import { ClienteAnaliseFinanceiraRevisarModule } from '../analise-financeira/revisar-modal';
import { ClienteArquivoModule } from '../arquivos';
import { ClienteAtividadeModule } from '../atividade';
import { ClienteCadastroModule } from '../cadastro';
import { ClienteCentralCompraModule } from '../central-compra';
import { ClienteCentralCompraV1Module } from '../central-compra-v1';
import { ClienteCentralCompraFormControlTextModule } from '../central-compra/form-control-text';
import { ClienteCentralCompraParticipanteFormModule } from '../central-compra/participante/form';
import { ClienteClassificacaoModule } from '../classificacao';
import { ClienteConcorrenteModule } from '../concorrente';
import { ClienteFinanceiroFormModule } from '../financeiro';
import { ClienteContratoFormModule } from '../components/contrato/cliente-contrato-form.module';
import { ClienteLogisticaFormModule } from '../components/logistica/cliente-logistica-form.module';
import { ClienteInternetSharedModule } from '../internet';
import { CardMessageCartaIsencaoIpiVencidaModule } from '../ipi/card-message-carta-isencao-ipi-vencida';
import { CardMessageDestaqueIpiModule } from '../ipi/card-message-destaque-ipi';
import { ClienteItemTipoModule } from '../item-tipo';
import { ClientePedidoModule } from '../pedido';
import { ClientePipeSharedModule } from '../pipes';
import { ClienteRevisaoConfirmarModule } from '../revisao';
import { ClienteSituacaoModule } from '../situacao';
import { ClienteTipoFiscalModule } from '../tipo-fiscal';
import { ClienteTituloModule } from '../titulo';
import { ClienteTypeaheadSharedModule } from '../typeahead';
import { ClienteUnidadeNegocio2Module } from '../unidade-negocio2';
import { ClienteFormComponent } from './cliente-form.component';
import { ClientePreInsertFormComponent } from './pre-insert';

@NgModule({
    imports: [
        SharedModule,
        MoedaPipeModule,
        PessoaSharedModule,
        PessoaTipoPipeModule,
        ClientePipeSharedModule,
        ClienteCadastroModule,
        ClienteSituacaoModule,
        ClienteCentralCompraV1Module,
        ClienteCentralCompraModule,
        ClienteCentralCompraFormControlTextModule,
        ClienteCentralCompraParticipanteFormModule,
        ClienteClassificacaoModule,
        PessoaTermoLGPDFormModule,
        ClienteArquivoModule,
        RepresentanteSharedModule,
        CidadeModule,
        ClienteUnidadeNegocio2Module,
        UnidadeNegocioSharedModule,
        UsuarioSharedModule,
        ClienteInternetSharedModule,
        CurvaAbcVendaModule,
        TituloReceberSituacaoModule,
        TituloReceberResumoModule,
        ClienteAtividadeModule,
        ClienteItemTipoModule,
        CardMessageCartaIsencaoIpiVencidaModule,
        CardMessageDestaqueIpiModule,
        ClienteAnaliseFinanceiraModule,
        ClienteAnaliseFinanceiraBtnOptionsModule,
        ClienteAnaliseFinanceiraConcluirModule,
        ClienteAnaliseFinanceiraRevisarModule,
        CampanhaSelectModule,
        CanalMidiaSocialSelectModule,
        CanalMidiaSocialInputGroupModule,
        OrigemSelectModule,
        OrigemInputGroupModule,
        ClientePedidoModule,
        CampanhaViewEmbeddedModule,
        ClienteRevisaoConfirmarModule,
        ClienteTypeaheadSharedModule,
        ClienteConcorrenteModule,
        ClienteTituloModule,
        SimplesNacionalFormModule,
        MEIFormModule,
        PessoaIPIFormModule,
        CNAEsViewModule,
        CNAEPipeModule,
        CapitalSocialFormControlTextModule,
        SocioViewModule,
        PessoaTipoCardControlRadioModule,
        ClienteFinanceiroFormModule,
        ClienteContratoFormModule,
        ClienteLogisticaFormModule,
        TabelaPrecoSelectModule,
        RegiaoSelectModule,
        ClienteTipoFiscalModule,
        CustomerShareIndicadorBadgeModule,
        CanalVendaInputGroupModule,
        CanalVendaSelectModule
    ],
    declarations: [
        ClienteFormComponent,
        ClientePreInsertFormComponent
    ],
    exports: [
        ClienteFormComponent
    ]
})
export class ClienteFormModule { }
